export default `
void main()
{
    gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
}
`